import React, { useContext, useEffect, useState, useCallback } from 'react'

import { DataContext } from '../../../context/DataContext'
import { useApi } from '../../../hooks/useApi'

import Button from '../../shared/Button'
import Loader from '../../shared/Loader'

const TrackingMap: React.FC = () => {
  const { loggedIn, companyColor, setOpenAuthStep, sale } = useContext(DataContext)
  const { getDeliveryMap } = useApi()

  const [loadingMap, setLoadingMap] = useState(false)
  const [showMap, setShowMap] = useState(false)
  const [map, setMap] = useState<string>('')
  const [isRm, setIsRm] = useState(true)

  const handleShowMap = useCallback(async () => {
    setLoadingMap(true)
    const mapurl = await getDeliveryMap()
    if (!mapurl.showMap) {
      setIsRm(false)
    }
    if (mapurl.error) {
      setLoadingMap(false)
      return
    }
    setMap(mapurl.mapUrl)
    setLoadingMap(false)
    setShowMap(true)
  }, [getDeliveryMap])

  const handleOpenMap = () => {
    if (!loggedIn) {
      setOpenAuthStep(1)
      return
    }
    handleShowMap()
  }

  useEffect(() => {
    if (loggedIn) {
      handleShowMap()
    }
  }, [loggedIn, handleShowMap])

  return (
    <div className="max-h-[200px] overflow-y-auto mt-2 items-center gap-4 justify-center w-full rounded-xl scrollbar-hide">
      {!loggedIn && !loadingMap && sale.hasMap &&
      (<div className='w-full h-8'>
        <Button
          companyColor={companyColor}
          text='Ver donde viene mi pedido'
          dark
          onClick={handleOpenMap}
        />
      </div>
      )}

      {loadingMap && <Loader />}

      {showMap && isRm &&
        <div className='w-full h-full'>
          <img src={map} alt='delivery map' />
        </div>
      }
    </div>
  )
}

export default TrackingMap
